export const getRelAttribute = (href, target) => {
    if (href && target === "_blank") {
        return "noopener noreferrer";
    }
    return undefined;
};
export const sizeToAntSize = (size) => {
    switch (size) {
        case "small":
            return "small";
        case "large":
            return "large";
        case "medium":
        default:
            return "middle";
    }
};
export const sizeToIconSize = (size) => {
    switch (size) {
        case "large":
            return "small";
        case "medium":
            return "extra-small";
        case "small":
            return "mini";
    }
};
export const variantToAntType = (variant) => {
    switch (variant) {
        case "primary":
            return "primary";
        case "plain":
            return "text";
        case "danger":
            return "primary";
        case "default":
        case "secondary":
        default:
            return "default";
    }
};
